export interface DataType {
  id: number,
  userName: string,
  mobile: string,
  disable: boolean,
  lockEndTime: string,
  registerTime: string,
  latestLoginTime: string,
  createTime: string,
  updateTime: string,
  lastAccessMerchantId: number,
  isAdmin: boolean
  role: string
}

export interface MerchantDataType {
    id: number;
    name: string;
    checked: boolean;
    createTime: string;
}

export const column = [
  {
    title: '用户名',
    dataIndex: 'userName',
    key: 'userName',
  },
  {
    title: '手机号',
    dataIndex: 'mobile',
    key: 'mobile',
  }
]

export const merchantColumn = [
  {
    title: '商户ID',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: '商户名称',
    dataIndex:'name',
    key:'name',
  }
]